import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import classNames from 'classnames'

class Tab extends Component {

  @autobind
  handleClick() {
    this.props.onOpenTab({
      target: {
        value: this.props.tab.value
      }
    })
  }

  render() {
    const { tab: { title }, active } = this.props
    return (
      <li
        className={classNames({ active })}
      >
        <a onClick={this.handleClick}>
          {title}
        </a>
      </li>
    )
  }
}

export default class TabNav extends Component {

  static propTypes = {
    active: PropTypes.string.isRequired,
    onTabChanged: PropTypes.func.isRequired,
    tabs: PropTypes.array.isRequired,
  }

  @autobind
  handleTabChange(e) {
    this.props.onTabChanged(e)
  }

  render() {
    const { active, tabs } = this.props
    return (
      <ul className="nav nav-tabs">
        {tabs.map((tab) => (
          <Tab
            key={tab.title}
            tab={tab}
            active={active === tab.value}
            onOpenTab={this.handleTabChange}
          />
        ))}
      </ul>
    )
  }

}



// WEBPACK FOOTER //
// ./src/shared/components/TabNav.js